
























import Vue from 'vue'
import { Route } from 'vue-router'
import store from '@/store'
import mobileRoot from '@/components/mobile-root.vue'
import desktopRoot from '@/components/desktop-root.vue'

export default Vue.extend({
  data() {
    return {
      storeState: store.state,
      alert: false
    }
  },
  components: {
    mobile: mobileRoot,
    desktop: desktopRoot
  },
  created() {
    store.setIsMobile()
    this.resizeSetIsMobile()
    this.showAlert()
  },
  computed: {
    root(): string {
      return this.storeState.isMobile ? 'mobile' : 'desktop'
    }
  },
  watch: {
    $route(to, from) {
      if (from.name) this.disabledAlert()
    }
  },
  methods: {
    resizeSetIsMobile() {
      let timer: number
      window.addEventListener('resize', () => {
        if (!timer) clearTimeout(timer)
        timer = setTimeout(() => store.setIsMobile(), 100)
      })
    },
    disabledAlert() {
      this.alert = false
      sessionStorage.setItem('alert', 'false')
    },
    showAlert() {
      const userAgent = window.navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
        if (!sessionStorage.getItem('alert')) {
          this.alert = true
        }
      }
    }
  }
})
